import type { SessionUser, Session } from 'next-auth'

export default () => {
  const { signIn: authSignIn, signOut: authSignOut } = useAuth()
  const nuxtApp = useNuxtApp()
  const router = useRouter()
  const route = useRoute()

  const loadSession = nuxtApp.$loadSession as () => Promise<Session>
  const isUserLoading = nuxtApp.$isUserLoading as ComputedRef<boolean>
  const status = nuxtApp.$authStatus as ComputedRef<string>
  const user = nuxtApp.$user as ComputedRef<SessionUser>
  const session = nuxtApp.$session as ComputedRef<Session>
  const i18n = nuxtApp.$i18n

  const signOut = async (options: any = { redirect: false }) => {
    try {
      // Clear cookie
      await authSignOut(options)
      // Update cached session.user since cookie is gone
      await loadSession()

      // Redirect to homepage if protected route
      if (route.meta.middleware === 'authenticated') {
        router.push(i18n.t('/'))
      }
    } catch (error) {
      console.error('Error during sign out:', error)
    }
  }

  const signIn = async (provider: string, options: any = {}) => {
    try {
      await signOut()
      const result = await authSignIn(provider, { redirect: false, ...options })

      // Redirect for credential authentication
      if (!result.error) options.callbackUrl && provider === 'credentials' ? await router.replace(options.callbackUrl) : await router.push('/')

      await loadSession()
      return result
    } catch (error) {
      console.error('Error during sign in:', error)
    }
  }

  return {
    signIn,
    signOut,
    status,
    loadSession,
    isUserLoading,
    user,
    session
  }
}
